import React from "react";
import styled from "styled-components";

const SubstackSignup = () => {
  return (
    <StyledSubstackSignup action="https://theoutlawocean.substack.com/api/v1/free?nojs=true" method="post" class="form " novalidate="">
      <input type="hidden" name="first_url" value="https://theoutlawocean.substack.com/embed" />
      <input type="hidden" name="first_referrer" value="http://localhost:8000/" />
      <input type="hidden" name="current_url" value="https://theoutlawocean.substack.com/embed" />
      <input type="hidden" name="current_referrer" value="http://localhost:8000/" />
      <input type="hidden" name="referral_code" />
      <input type="hidden" name="source" value="embed" />
      <input type="hidden" name="referring_pub_id" />
      <input type="hidden" name="additional_referring_pub_ids" />
      <input type="email" name="email" placeholder="Type your email…" />
      <button class="button rightButton  primary subscribe-btn" type="submit" tabindex="0">Subscribe</button>
      <div id="error-container"></div>
    </StyledSubstackSignup>
  )
}
export default SubstackSignup;

const StyledSubstackSignup = styled.form`

`;

/* 
<StyledSubstackSignup src="https://theoutlawocean.substack.com/embed" width="480" height="320" frameborder="0" scrolling="no" />
*/